import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, isRef as _isRef, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "mt-8" }
const _hoisted_2 = { class: "flex flex-wrap space-y-2 md:flex-nowrap md:space-y-0 md:space-x-2" }
const _hoisted_3 = { class: "flex w-full md:w-2/5 lg:w-2/5" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-search",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" })
], -1)
const _hoisted_5 = { class: "whitespace-nowrap" }
const _hoisted_6 = { class: "flex w-full md:w-2/5 lg:w-2/5" }
const _hoisted_7 = {
  class: "capitalize",
  value: "all"
}
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "flex justify-end w-full md:w-1/5 lg:w-2/5" }
const _hoisted_10 = { class: "mt-8" }

import { ref } from "vue";
import { useRoute, useRouter } from "vue-router";

import TemplateBlock from "@/components/TemplateBlock.vue";
import RouterButton from "@/components/RouterButton.vue";
import TitleHeader from "@/components/TitleHeader.vue";
import RoleGuard from "@/components/RoleGuard.vue";

import api from "@/api/api";
import { PaginationMeta, Template } from "@/types";
import PaginationBar from "@/components/PaginationBar.vue";
import { useGlobalStore, useUserStore } from "@/store";
import { userHasRole } from "@/utils/roles";
import { useFilters } from "@/composables/filters";


export default /*#__PURE__*/_defineComponent({
  __name: 'TemplatesList',
  async setup(__props) {

let __temp: any, __restore: any

const route = useRoute();
const router = useRouter();
const userStore = useUserStore();
const globalStore = useGlobalStore();

const types = ref([] as any[]);
const templates = ref([] as Template[]);
const meta = ref({} as PaginationMeta);

const search = ref("");
let type = ref("all");

const { filters, getFiltersFromQuery, setFilter } = useFilters(route);

async function fetchTemplates() {
  const page = route.query.page || "1";

  // Fetch templates based on current query parameters
  const response = await api.templates.listTemplates(String(page), filters.value);

  templates.value = response.data.templates;
  meta.value = response.meta;

  types.value = [
    ...globalStore.course_types,
    {
      name: "Archived",
      slug: "archived",
    },
  ];
}

getFiltersFromQuery();
;(
  ([__temp,__restore] = _withAsyncContext(() => fetchTemplates())),
  await __temp,
  __restore()
);

if (route.query.type) {
  type.value = route.query.type as string;
} else {
  type.value = "all";
}

if (!userHasRole(userStore.user.roles, ["admin", "courses-admin", "trainer-organisation"])) {
  router.push({ path: "/error" });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(TitleHeader, {
        title: _ctx.$t('courses')
      }, null, 8, ["title"])
    ]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _withDirectives(_createElementVNode("input", {
            type: "search",
            id: "search",
            onKeydown: _cache[0] || (_cache[0] = _withKeys(($event: any) => (_unref(setFilter)('search', search.value)), ["enter"])),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((search).value = $event)),
            class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded-l",
            placeholder: "Search ...",
            required: ""
          }, null, 544), [
            [_vModelText, search.value]
          ]),
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(setFilter)('search', search.value))),
            type: "submit",
            class: "flex items-center h-10 px-4 py-2 space-x-2 text-white rounded-r bg-primary hover:bg-blue-700 focus:ring-4 focus:outline-none focus:ring-blue-300"
          }, [
            _hoisted_4,
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("search")), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _withDirectives(_createElementVNode("select", {
            onChange: _cache[3] || (_cache[3] = ($event: any) => (_unref(setFilter)('type', _unref(type)))),
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(type) ? (type).value = $event : type = $event)),
            id: "language",
            name: "language",
            class: "capitalize text-black border rounded w-full focus:outline-none focus:shadow-outline-primary font-normal transition duration-50 ease-in px-3 py-1.5 h-10 border-gray-600"
          }, [
            _createElementVNode("option", _hoisted_7, _toDisplayString(_ctx.$t("all")), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(types.value, (type) => {
              return (_openBlock(), _createElementBlock("option", {
                key: type.slug,
                value: type.slug,
                class: "capitalize"
              }, _toDisplayString(type.name), 9, _hoisted_8))
            }), 128))
          ], 544), [
            [_vModelSelect, _unref(type)]
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(RoleGuard, { roles: ['admin', 'courses-admin'] }, {
            default: _withCtx(() => [
              _createVNode(RouterButton, {
                type: "primary",
                loading: false,
                disabled: false,
                to: { path: '/dashboard/courses/templates/new' }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("add-course-template")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(templates.value, (template) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "px-4 py-2 border first:rounded-t last:rounded-b border-gray-50",
            key: template.id
          }, [
            _createVNode(TemplateBlock, { template: template }, null, 8, ["template"])
          ]))
        }), 128))
      ]),
      _createVNode(PaginationBar, { meta: meta.value }, null, 8, ["meta"])
    ])
  ], 64))
}
}

})